import { render } from "./vsharedvcmap.vue?vue&type=template&id=d2641f8c&scoped=true"
import script from "./vsharedvcmap.vue?vue&type=script&lang=js"
export * from "./vsharedvcmap.vue?vue&type=script&lang=js"

import "./vsharedvcmap.vue?vue&type=style&index=0&id=d2641f8c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2641f8c"]])

export default __exports__